import { createRef } from "react";

const States = {
  sections: 3,
  pages: 3,
  zoom: 1,
  top: createRef(),
};

export default States;